import { connect } from 'react-redux';

import CollectionFilterPane from 'components/CollectionFilterPane';
import Catalog from 'state/selectors/catalog';
import CollectionPage from 'state/selectors/collection-page';
import Filters, { COLLECTION_PAGE_FILTER_IDENTIFIERS } from 'utils/Filters';

const mapStateToProps = (state, ownProps) => {
  const parentCollectionHandle = CollectionPage.getCollectionHandle(state);
  const isLoading = Catalog.isParentCollectionLoading(state, parentCollectionHandle);
  const collectionCacheKey = Catalog.getParentCollectionCacheKey(state, parentCollectionHandle);

  // When the collection is loading, return all possible filter identifiers which will be shown as placeholders.
  // Otherwise, only show relevant filters based on the current set of collection items
  const filterIdentifiers = isLoading
    ? COLLECTION_PAGE_FILTER_IDENTIFIERS
    : Filters.determineRelevantCollectionPageFilterIdentifiers({
        items: Catalog.getAvailableParentCollectionColorways(state, parentCollectionHandle),
        cacheKey: collectionCacheKey,
      });

  return {
    isLoading,
    filterIdentifiers,
    ...ownProps,
  };
};

export default connect(mapStateToProps)(CollectionFilterPane);
